

































































































































import Vue from 'vue';
import { Type, TypeMap, Expression, ExpressionMap, NoExpression, DefineExpression, objectMap, objectValues, ObjectType, Traverser, GetExpression, SetExpression, UpdateExpression, ConstantExpression, ChainExpression } from 'expangine-runtime';
import { obj, renameVariable } from '@/common';
import { Preferences, PreferenceCategory } from '@/app/Preference';
import { ShortcutContext } from '@/app/Shortcuts';
import ExpressionBase from '../ExpressionBase';


const PREF_SHORTCUT_DEFINE_ADD = Preferences.define({
  key: 'shortcut_define_add',
  label: 'Add Define expression variable shortcut',
  category: [PreferenceCategory.EXPRESSION, PreferenceCategory.SHORTCUT],
  defaultValue: '187__c',
  component: 'ex-shortcut-input',
});


export default ExpressionBase<DefineExpression>().extend({
  name: 'DefineEditor',
  data: () => ({
    sorting: false,
  }),
  computed: {
    bodyContext(): Type {
      return this.getContextAt(this.value.define.length);
    },
    isEmpty(): boolean {
      return this.value.define.length === 0;
    },
    hasVariables(): boolean {
      return this.value.define.length > 1;
    },
    hasChain(): boolean {
      return this.value.body instanceof ChainExpression;
    },
    defineShortcuts(): ShortcutContext {
      return { 
        downs: {
          [Preferences.get(PREF_SHORTCUT_DEFINE_ADD)]: this.addVar,
        },
      };
    },
  },
  mounted() {
    this.addIfEmpty();
  },
  methods: {
    removeDefine(): void {
      this.input(this.value.body);
    },
    addIfEmpty(): void {
      if (this.value.define.length === 0) {
        this.value.define.push(['', NoExpression.instance]);
      }
    },
    toggleSort(): void {
      this.sorting = !this.sorting;
    },
    updateBody(body?: Expression): void {
      this.value.body = body || NoExpression.instance;
      this.update();
    },
    addVar(): void {
      this.value.define.push([this.getNextVarName(), NoExpression.instance]);
    },
    getContextAt(index: number): Type {
      const defs = this.registry.defs;
      const scope = obj() as TypeMap;
      let context = this.context;

      for (let i = 0; i < index; i++) {
        const [name, expr] = this.value.define[i];
        const exprType = expr.getType(defs, context);

        if (exprType) {
          scope[name] = exprType;
          context = defs.getContext(context, scope);
        }
      }

      return context;
    },
    getNextVarName(): string {
      const names = 'abcdefghijklmnopqrstuvwxyz'.split('');
      let next = names.find((name) => !this.hasVar(name));
      if (!next) {
        let index = 0;
        next = 'temp';
        while (this.hasVar(next)) {
          next = 'temp' + index;
          index++;
        }
      }
      return next;
    },
    hasVar(name: string) {
      return this.value.define.some(([n]) => n === name) || this.hasContextVar(name);
    },
    isVarInvalid(index: number): boolean {
      const [name, expr] = this.value.define[index];

      return expr === NoExpression.instance
        || !name
        || this.hasContextVar(name)
        || this.value.define.some(([other], otherIndex) => other === name && index !== otherIndex);
    },
    isVarsValid(): boolean {
      return !this.value.define.some((pair, index) => this.isVarInvalid(index));
    },
    changeVarExpression(index: number, expr?: Expression): void {
      this.$set(this.value.define[index], 1, expr || NoExpression.instance);
      this.update();
    },
    changeVar(index: number, newName: string): void {
      const oldName = this.value.define[index][0];
      const skipRenaming = this.isVarInvalid(index);

      this.$set(this.value.define[index], 0, newName);

      if (skipRenaming) {
        return;
      }

      if (oldName && oldName !== newName) {
        renameVariable(this.value.body, oldName, newName);

        for (let i = index + 1; i < this.value.define.length; i++) {
          renameVariable(this.value.define[i][1], oldName, newName);
        }
      }

      this.update();
    },
    removeVar(index: number): void {
      this.value.define.splice(index, 1);
      this.update();
    },
  },
});
